export default "__VITE_ASSET__7vy5AFME__"